import * as React from "react";

import { Input } from "src/components/ui/input";
import { cn } from "src/lib/utils";
import { EyeIcon, EyeSlash } from "src/svg";
import { Field, type FieldProps } from "./Field";

export type PasswordFieldProps = Omit<React.ComponentProps<"input">, "children" | "type"> &
	Pick<FieldProps, "label" | "error" | "hint"> & {
		containerClassName?: string;
	};

/** Password input with a show/hide toggle. */
export const PasswordField = ({
	label,
	error,
	hint,
	required,
	name,
	containerClassName,
	className,
	...props
}: PasswordFieldProps) => {
	const [visible, setVisible] = React.useState(false);

	return (
		<Field label={label} name={name} required={required} error={error} hint={hint} className={containerClassName}>
			<div className="tw-relative">
				<Input
					id={name}
					name={name}
					type={visible ? "text" : "password"}
					aria-invalid={!!error}
					className={cn("tw-pr-11", error && "tw-border-red focus-visible:tw-border-red focus-visible:tw-ring-red/20", className)}
					{...props}
				/>
				<button
					type="button"
					onClick={() => setVisible((prev) => !prev)}
					aria-label={visible ? "Hide password" : "Show password"}
					className="tw-absolute tw-right-1 tw-top-1/2 -tw-translate-y-1/2 tw-rounded-full tw-p-2 tw-text-text-soft tw-transition-colors hover:tw-bg-bg hover:tw-text-text"
				>
					{visible ? <EyeIcon className="tw-size-4" /> : <EyeSlash className="tw-size-4" />}
				</button>
			</div>
		</Field>
	);
};

export default PasswordField;
